module.exports = __webpack_public_path__ + "img/business-english-en.9336b6b7.png";